export default __webpack_public_path__ + "static/media/LAS0880.34I-39648_-23538_0.9ddf7007.jpg";